import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssaySoftwareProject extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword_left}>Running head: TITLE OF PAPER IN CAPS</div>
          <div className={styles.catchword}>1</div>

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <div className={styles.center}>Software Project Decision Point</div>
              <div className={styles.center}>Name of Student</div>
              <div className={styles.center}>Institution Affiliation</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the APA formatting style.</li>
                  <li>No personal information is included. </li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting. </li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword_left}>Software Project Decision Point</div>
          <div className={styles.catchword}>2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <div className={styles.center}>Software Project Decision Point</div>
              <div className={styles.center}><b>Return of investments (ROI) analysis</b></div>
              <p>1. <i>Option 1</i> carries the following costs -$200,000 - $85,000 - $50,000 - 5*$40,000 = - $535,000. However, it will save 5*$61,000 = $305,000. As a result, the amount the company will spend is $230,000. Therefore, the total cost of ownership (TCO) is $230,000 for this option.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: The paper analyzes two options.</li>
                  <li>Structure: Each of the options is addressed separately. Each paragraph is devoted to one idea.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>For the <i>Option 2</i>, the spending will be as follows -$250,000 - 3*$75,000 = - $475,000. The company will be able to save 5*$25,000 = $125,000. Thus, the company will have to spend $350,000 on this software. It means that TCO for this option is $350,000.</p>
              <p>Since the second option requires more financial costs, while both of the options are predicted to bring the same profit, it is necessary to select the first option.</p>

              <div className={styles.comment}>
                <ul>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>2. ROI = (Gain from Investment - Cost of Investment) / Cost of Investment</p>
              <p><i>Option 1</i>: Gain from Investment = $1,000,000* 1.1 + $1,100,000 * 1.1 + $1,210,000 * </p>
              <p> 1.1 + $1,331,000 * 1.1 + $1,464,100*1.1 = $6,716,000</p>
              <p>Cost of Investment = $230,000</p>
              <p>ROI = ($6,716,000 - $230,000) / $230,000 = %28.2</p>
              <p><i>Option 2</i>: Gain from Investment = $6,716,000</p>
              <p>Cost of Investment = $350,000</p>
              <p>ROI = ($6,716,000 - $350,000) / $350,000= %19.9</p>

              <div className={styles.comment}>
                <ul>
                  <li>Content: The required option is addressed. The calculations are provided and explained.</li>
                  <li>Word count requirement is met.</li>
                  <li>There are no References, as they are not required in the instructions.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>To alleviate such damaging behavior, more nurses should work on one floor. This will divide the work and attention between more professionals and lessen the necessity to bend the rules in order to meet the goals. </p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis. </li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssaySoftwareProject);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssaySoftwareProject.js